// import React, { useRef } from 'react';
// import { Palette, Crown, Ruler } from 'lucide-react';

// export default function RomanShades() {
//     const whatWeOfferRef = useRef(null); 
    
//       const scrollToSection = () => {
//         if (whatWeOfferRef.current) {
//           whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
//         }
//       };
//   const gallery = [
//     "images/roman3.jpg",
//     "images/roman.jpg",

//     "images/roman2.webp",
//   ];

//   return (
//     <div className=' font-playfair'>
//       {/* Hero Section */}
//       <section className="relative h-[75vh] bg-neutral-100">
//         <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-amber-100 via-neutral-100 to-neutral-100"></div>
//         <div className="relative h-full max-w-7xl mx-auto px-4 flex items-center">
//           <div className="w-full md:w-1/2 space-y-8">
//             <h1 className="text-5xl md:text-9xl font-bold text-gray-900">Roman Shades</h1>
//             <p className="text-xl text-gray-600">Timeless elegance meets modern functionality</p>
//             <button onClick={scrollToSection} className="px-8 py-3 bg-gray-900 text-white  hover:bg-gray-800 transition-colors">
//               Explore Collection
//             </button>
//           </div>
//           <div className="hidden md:block w-1/2">
//             <img
//               src='images/roman1.jpg'
//               alt="Roman shades elegance"
//               className="w-full h-[500px] object-cover rounded-2xl shadow-2xl"
//             />
//           </div>
//         </div>
//       </section>

//       {/* Features */}
//       <section className="py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
//             {[
//               {
//                 icon: <Palette className="w-8 h-8" />,
//                 title: "Custom Fabrics",
//                 description: "Choose from premium materials and patterns"
//               },
//               {
//                 icon: <Crown className="w-8 h-8" />,
//                 title: "Classic Style",
//                 description: "Soft folds create a luxurious appearance"
//               },
//               {
//                 icon: <Ruler className="w-8 h-8" />,
//                 title: "Perfect Fit",
//                 description: "Custom sizes for any window"
//               }
//             ].map((feature, index) => (
//               <div key={index} className="group">
//                 <div className="h-20 w-20 bg-amber-50 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-amber-100 transition-colors">
//                   <div className="text-amber-700">{feature.icon}</div>
//                 </div>
//                 <h3 className="text-2xl md:text-3xl font-bold mb-4">{feature.title}</h3>
//                 <p className="text-xl md:text-xl text-gray-600">{feature.description}</p>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Gallery */}
//       <section ref={whatWeOfferRef} className="py-20 px-4 bg-neutral-50">
//         <div className="max-w-7xl mx-auto">
//           <h2 className="text-4xl md:text-7xl font-bold text-center mb-16">Design Gallery</h2>
//           <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
//             {gallery.map((image, index) => (
//               <div key={index} className="group cursor-pointer">
//                 <div className="relative overflow-hidden rounded-xl">
//                   <img
//                     src={image}
//                     alt={`Roman shade design ${index + 1}`}
//                     className="w-full h-[400px] object-cover transition-transform duration-700 group-hover:scale-110"
//                   />
//                   <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
//                     <div className="absolute bottom-6 left-6 right-6">
//                       <h3 className="text-white text-xl font-bold">Collection {index + 1}</h3>
//                       <p className="text-white/80 mt-2">Discover our signature designs</p>
//                     </div>
//                   </div>
//                 </div>
//               </div>
//             ))}
//           </div>
//         </div>
//       </section>

//       {/* Features Grid */}
//       <section className="py-20 px-4">
//         <div className="max-w-6xl mx-auto">
//           <div className="grid grid-cols-1 md:grid-cols-2 gap-16">
//             <div>
//               <h2 className="text-3xl  md:text-6xl font-bold mb-8">Design Features</h2>
//               <div className="space-y-6">
//                 <div className="flex items-start space-x-4">
//                   <div className="w-1 h-1 bg-amber-500 rounded-full mt-3"></div>
//                   <div>
//                     <h3 className="text-xl font-semibold mb-2 md:text-4xl">Soft Fold Design</h3>
//                     <p className="text-gray-600 md:text-xl">Creates elegant, cascading folds when raised</p>
//                   </div>
//                 </div>
//                 <div className="flex items-start space-x-4">
//                   <div className="w-1 h-1 bg-amber-500 rounded-full mt-3"></div>
//                   <div>
//                     <h3 className="text-xl font-semibold mb-2 md:text-4xl">Light Control</h3>
//                     <p className="text-gray-600 md:text-xl">Multiple fabric options for desired light filtering</p>
//                   </div>
//                 </div>
//                 <div className="flex items-start space-x-4">
//                   <div className="w-1 h-1 bg-amber-500 rounded-full mt-3"></div>
//                   <div>
//                     <h3 className="text-xl font-semibold mb-2 md:text-4xl">Cordless Operation</h3>
//                     <p className="text-gray-600 md:text-xl">Safe and convenient operation options</p>
//                   </div>
//                 </div>
//               </div>
//             </div>
//             <div>
//               <img
//                 src={gallery[1]}
//                 alt="Roman shade features"
//                 className="w-full h-[400px] object-cover rounded-xl shadow-lg"
//               />
//             </div>
//           </div>
//         </div>
//       </section>
//     </div>
//   );
// }

import React, { useRef } from 'react';
import { Palette, Crown, Ruler } from 'lucide-react';

export default function RomanShades() {
    const whatWeOfferRef = useRef(null); 
    
    const scrollToSection = () => {
        if (whatWeOfferRef.current) {
            whatWeOfferRef.current.scrollIntoView({ behavior: "smooth" });
        }
    };

    const gallery = [
        "images/roman3.jpg",
        "images/roman.jpg",
        "images/roman2.webp",
        "images/romanshades.webp",
        "images/romanshades1.webp",
        "images/romanshades2.webp",


    ];

    return (
        <div className='font-playfair'>
            {/* Hero Section */}
            <section className="relative h-[75vh] bg-neutral-100 ">
                <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_right,_var(--tw-gradient-stops))] from-amber-100 via-neutral-100 to-neutral-100"></div>
                <div className="relative h-full max-w-7xl mx-auto px-4 flex flex-col md:flex-row items-center">
                    <div className="w-full md:w-1/2 space-y-8">
                        <h1 className="text-4xl md:text-6xl lg:text-9xl font-bold text-gray-900 text-center md:text-left">Roman Shades</h1>
                        <h2 className="text-lg md:text-xl text-gray-600 text-center md:text-left">Timeless elegance meets modern functionality</h2>
                        <div className='flex  justify-center md:justify-start'>
                        <button onClick={scrollToSection} className="px-8 py-3 bg-gray-900 text-white hover:bg-gray-800 transition-colors ">
                            Explore Collection
                        </button>
                        </div>
                      
                    </div>
                    <div className="mt-12 md:w-1/2 md:mt-0">
                        <img
                            src='images/roman1.jpg'
                            alt="Roman shades elegance"
                            className="w-full h-[400px] md:h-[500px] object-cover rounded-2xl shadow-2xl"
                        />
                    </div>
                </div>
            </section>

            {/* Features */}
            <section className="py-20 px-4">
                <div className="">
                    <div className="flex flex-col md:flex-row gap-20 justify-around ">
                        {[{
                            icon: <Palette className="w-8 h-8" />,
                            title: "Custom Fabrics",
                            description: "Choose from premium materials and patterns"
                        },
                        {
                            icon: <Crown className="w-8 h-8" />,
                            title: "Classic Style",
                            description: "Soft folds create a luxurious appearance"
                        },
                        {
                            icon: <Ruler className="w-8 h-8" />,
                            title: "Perfect Fit",
                            description: "Custom sizes for any window"
                        }].map((feature, index) => (
                            <div key={index} className="group">
                                <div className="h-20 w-20 bg-amber-50 rounded-2xl flex items-center justify-center mb-6 group-hover:bg-amber-100 transition-colors">
                                    <div className="text-amber-700">{feature.icon}</div>
                                </div>
                                <h3 className="text-xl md:text-2xl lg:text-3xl font-bold mb-4">{feature.title}</h3>
                                <p className="text-lg md:text-xl text-gray-600">{feature.description}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            <div className="flex flex-col xl:gap-20 xl:px-20 2xl:px-40">
        {/* Header Section */}
        <header className="text-center pt-20">
          <h1 ref={whatWeOfferRef} className="text-4xl md:text-5xl lg:text-8xl font-extrabold text-gray-900 mb-8 ">Roman Shades</h1>
        </header>

        {/* About Roman Shades */}
        <section className="mb-16 px-3 flex  flex-col lg:flex-row gap-6 xl:gap-20 justify-between items-center">
          <h2 className="text-2xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800  text-center">What are Roman Shades?</h2>
          <p className=" text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
          Roman Shades are versatile window treatments that provide enhanced convenience, privacy,
          and energy efficiency. Designed to suit your needs, they offer a stylish and functional solution for any space.
          </p>
        </section>

        {/* Benefits of Roman Shades */}
        <section className="mb-16 px-3 flex flex-col lg:flex-row gap-10 md:gap-20 justify-between items-center">
          {/* < className=" text-xl text-gray-700"> */}
            <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify">
            Roman Shades offer a simple and effective way to enhance privacy, control light, and improve energy efficiency. Easily adjust the blinds to suit your needs, providing
            comfort and style for any space. Perfect for maintaining privacy while allowing natural light to filter through
            </p>

          <h2 className="text-4xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 text-center">Benefits of Roman Shades</h2>

        </section>

        {/* How Roman Shades Work */}
        <section className="xl:mb-16 px-3 flex flex-col lg:flex-row gap-5 xl:gap-20 justify-between items-center">
          <h2 className="text-3xl md:text-6xl 2xl:text-8xl font-semibold text-gray-800 mb-4 text-center">How Do Roman Shades Work?</h2>
          <p className="text-xl md:text-2xl xl:text-3xl 2xl:text-4xl text-gray-700 max-w-lg lg:max-w-lg xl:max-w-xl text-justify ">
          Roman Shades are a practical solution for controlling light and privacy. Easily adjust the blinds to suit your needs, providing a smooth and quiet operation.
          Perfect for enhancing comfort and energy efficiency in any space, while maintaining a stylish and functional look
          </p>
        </section>
        </div>

            {/* Gallery */}
            <section ref={whatWeOfferRef} className="py-20 px-4 bg-neutral-50">
                <div className="max-w-7xl mx-auto">
                    <h2 className="text-4xl md:text-5xl lg:text-7xl font-bold text-center mb-16">Design Gallery</h2>
                    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-8">
                        {gallery.map((image, index) => (
                            <div key={index} className="group cursor-pointer">
                                <div className="relative overflow-hidden rounded-xl">
                                    <img
                                        src={image}
                                        alt={`Roman shade design ${index + 1}`}
                                        className="w-full h-[300px] sm:h-[350px] md:h-[400px] lg:h-[450px] object-cover transition-transform duration-700 group-hover:scale-110"
                                    />
                                    <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                        <div className="absolute bottom-6 left-6 right-6">
                                            <h3 className="text-white text-xl lg:text-2xl font-bold">Collection {index + 1}</h3>
                                            <p className="text-white/80 mt-2">Discover our signature designs</p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>

            {/* Features Grid */}
            <section className="py-20 px-4">
                <div className="max-w-6xl mx-auto">
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-16">
                        <div>
                            <h2 className="text-3xl md:text-4xl lg:text-6xl font-bold mb-8">Design Features</h2>
                            <div className="space-y-6">
                                {[{
                                    title: "Soft Fold Design",
                                    description: "Creates elegant, cascading folds when raised"
                                }, {
                                    title: "Light Control",
                                    description: "Multiple fabric options for desired light filtering"
                                }, {
                                    title: "Cordless Operation",
                                    description: "Safe and convenient operation options"
                                }].map((feature, index) => (
                                    <div key={index} className="flex items-start space-x-4">
                                        {/* <div className="w-1 h-1 bg-amber-500 rounded-full mt-3"></div> */}
                                        <div>
                                            <h3 className="text-xl md:text-2xl lg:text-4xl font-semibold mb-2">{feature.title}</h3>
                                            <p className="text-gray-600 md:text-xl">{feature.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                        <div>
                            <img
                                src={gallery[4]}
                                alt="Roman shade features"
                                className="w-full h-[350px] sm:h-[400px] lg:h-[450px] object-cover rounded-xl shadow-lg"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
}
